import { useAsync } from '@arcxmoney/arcx-react'

export function useLocation() {
  const [location, error] = useAsync(async () => {
    const result = await fetch('https://extreme-ip-lookup.com/json/')
    const { country, countryCode } = await getJsonOrText(result)
    return {
      country,
      countryCode,
    }
  }, [])

  const fetchError =
    error?.stack && 'Cannot determine your location. Turn off blocking adds, please'
  return {
    location,
    error: fetchError,
    loading: !location && !error,
  }
}

async function getJsonOrText(res: Response) {
  return res.text().then((text) => {
    try {
      return JSON.parse(text)
    } catch (e) {
      return text
    }
  })
}
